module.exports = __webpack_public_path__ + "static/img/banner-cursos-interior-768x1024.26d96dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-cursos/banner-cursos-interior-768x1024.jpg
// module id = YNLW
// module chunks = 47